import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getManageTerminologyAsync, UpdateManageTerminologiesAsync } from "./manageTerminologySlice";
import { ShowToast } from "../../../common/Toastr";
import ManageTerminologyTable from './ManageTerminologyTable'
import { ShowSwal } from '../../../common/SweetAlert';
import { useTranslation } from "react-i18next";
import { getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import { getValueFromResource } from "../../../common/timeLiveFunction";
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';

const ManageTerminology = () => {
  const dispatch = useAppDispatch();
  const modelRef = useRef<any>(null);
  const { manageTerminologyList, isReload, isLoading, selectedRecord } = useAppSelector((state) => state.manageTerminology);
  const { t } = useTranslation();
  const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const fetchPagePermissions = async () => {
      if (pageId && pageId !== '') {
        const res = await dispatch(getPagePermissionsAsync(pageId));
        if (!res.payload.IsList) {
          navigate('../error/403');
        }
      } else if (!pageId && menuList && menuList.length > 0) {
        const routeName = location.pathname.split('/').filter(Boolean)[0];
        const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
        if (foundItem) {
          const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
          if (!res.payload.IsList) {
            navigate('../error/403');
          }
        } else {
          navigate('../error/403');
        }
      }
    };

    fetchPagePermissions();
  }, [dispatch, location.pathname, menuList, navigate, pageId]);

  useEffect(() => {
    if (isReload) {
      dispatch(getManageTerminologyAsync());
    }
  }, [isReload])

  useEffect(() => {
    dispatch(getManageTerminologyAsync());
  }, [dispatch])

  const handleOnClickEvent = () => {
    {
      const array = manageTerminologyList.filter(x => x.isSelected === 1 && ((x.TerminologyName === null || x.TerminologyName === "") || (x.UserDefinedName === null || x.TerminologyName === "")));
      if (array.length > 0) {

        ShowSwal('ATTENTION PLEASE', "Data is missing in one or more enabled fields.", "warning");
      }
      else {
        dispatch(UpdateManageTerminologiesAsync(manageTerminologyList))
          .unwrap()
          .then((originalPromiseResult) => {
            ShowToast(originalPromiseResult.message, 'Success', "success", "toast-top-right");
            window.location.reload();
          })
          .catch((rejectedValueOrSerializedError) => {
            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
          })
      }
    }
  }

  return (
    <>
  {isLoading && <Loader />}

      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top fixed-top bg-white">
          <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1" >
            {/* {t('Manage Terminology')} */}
            {getValueFromResource('Manage Terminology', dispatch, t)}
            <div
              style={{ marginBottom: "2px" }}
              data-tooltip-id="tooltip-manageTerminology"
              data-tooltip-content={getValueFromResource("Customize the labels used throughout the application by renaming standard terms such as Task, Project, Employee, or Client. Changes are reflected across the user interface without affecting the underlying data.", dispatch, t)}
            >
              <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
            </div>

          </h3>
          <div className="card-toolbar">
            {IsEdit &&
              <a id="btnUpdate"
                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                onClick={handleOnClickEvent}>
                {/* {t('Update Terminology')} */}
                {getValueFromResource('Update Terminology',dispatch, t)}

              </a>
            }
          </div>
        </div>
        {/* <div className="card-body"> */}
        <div className="card-Report-body">
          <div className="table-responsive">
            {IsList &&
              <ManageTerminologyTable manageTerminologyList={manageTerminologyList} t={t} />
            }
          </div>
        </div>
      </div >
      <ReactTooltip
        id="tooltip-manageTerminology"
        style={TOOLTIP_STYLE}
        place="bottom"
        delayShow={100}
        delayHide={100}
        clickable
        render={({ content }) => {
          const isLongContent = content && content?.length > 90;
          return (
            <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
              {content}
            </div>
          );
        }}
      />
    </>
  )
}
export default ManageTerminology